import isNil from 'lodash/isNil';
import {
  BROWSER_PERSISTED_STORAGE_PREFIX,
} from 'utils/storage';

const BROWSER_ID_KEY = `${BROWSER_PERSISTED_STORAGE_PREFIX}browser_id`;
const TAB_ID_KEY = `${BROWSER_PERSISTED_STORAGE_PREFIX}tab_id`;

function getOrCreate(storage: Storage, key: string): string {
  const item = storage.getItem(key);
  let id: string = item ?? '';
  if (isNil(item)) {
    id = crypto.randomUUID();
    storage.setItem(key, id);
  }
  return id;
}

export const browserId = getOrCreate(localStorage, BROWSER_ID_KEY);
export const tabId = getOrCreate(sessionStorage, TAB_ID_KEY);
